// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"162":"021a0e7430d32bfa3257","189":"f38c8172cee2ff70b113","404":"022fb9f3602557fb9dcb","406":"14360ef9000ec864ad76"}[chunkId] + ".css";
};